import { Bomb } from 'lucide-react';
import ErrorView from './ErrorView';

function UnhandledError() {
  return (
    <ErrorView
      title="Unexpected Error"
      heading="We're sorry, an unexpected error has occurred."
      message="Please return to the homepage and try your request again."
      buttonText="Return to Homepage"
      icon={Bomb}
    />
  );
}

export default UnhandledError;
